import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";
import { useGetRenewVisaBasicInformationDocumentGroupInfo } from "@/api/services/main/renew-visa";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { BasicInfoStepCard } from "@/features/renew-visa/components/basicInfoStep/BasicInfoStepCard";
import { FC } from "react";

export type TRenewVisaBasicInfoStepProps = {
  isSkipStep: boolean;
  stepGroupData: TEmployeeRenewVisaDocumentStepGroup;
  readonly: boolean;
};

export const RenewVisaBasicInfoStep: FC<TRenewVisaBasicInfoStepProps> = ({ isSkipStep, stepGroupData, readonly }) => {
  const { id: renewVisaDocumentStepGroupId } = stepGroupData;
  const { data: basicInfoData, isLoading } = useGetRenewVisaBasicInformationDocumentGroupInfo({ renewVisaDocumentStepGroupId });

  if (isLoading) return <LoadingArea />;
  return <BasicInfoStepCard isSkipStep={isSkipStep} stepGroupData={stepGroupData} basicInfoData={basicInfoData} readonly={readonly} />;
};
